/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2021-10-22 17:27:42
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/ErrorModal/ErrorModal.tsx
 */
import React from 'react';
import css from './ErrorModal.less';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
const ErrorModal = (props) => {
  const { setModal, onSubmit, errorText, okText, hideOKCancel } = props;

  const onCancel = () => {
    if (setModal) setModal(false);
  };

  const onOk = () => {
    if (onSubmit) onSubmit();
    if (setModal && !hideOKCancel) setModal(false);
  };
  return (
    <React.Fragment>
      <div className={css.errorText}>{errorText}</div>
      <ModalFooter danger okText={okText} onCancel={onCancel} onOk={onOk} />
    </React.Fragment>
  );
};
export default ErrorModal;
